export const DESTINATION_STATUS = {
  FAILED: 'failed',
  PENDING: 'pending',
  RESOLVED: 'resolved',
};
